import { BoxProps } from "@chakra-ui/react";

export const tableFrameProps: BoxProps = {
  bgColor: "white",
  borderWidth: "1px",
  borderColor: "gray.200",
  borderRadius: "0.5rem",
  boxShadow: "sm",
};
